module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-card', {
    staticClass: "filters-card",
    attrs: {
      "shadow": "hover"
    }
  }, [_c('div', {
    staticClass: "el-row el-align-middle el-justify-space-between",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v("Filters")]), _vm._v(" "), _c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "text",
      "size": "small",
      "icon": "el-icon-refresh-left"
    },
    on: {
      "click": _vm.resetFilters
    }
  }, [_vm._v("\n      Clear All\n    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-section"
  }, [_c('h4', [_vm._v("Quick Filters")]), _vm._v(" "), _vm._l((_vm.quickFilters), function(filter) {
    return _c('el-button', {
      key: filter.label,
      staticStyle: {
        "margin": "4px 4px 4px 0",
        "min-width": "100px",
        "text-align": "center"
      },
      attrs: {
        "type": filter.active ? 'primary' : '',
        "size": "small"
      },
      on: {
        "click": function($event) {
          return _vm.toggleFilters(filter)
        }
      }
    }, [_c('i', {
      class: filter.icon
    }), _vm._v(" " + _vm._s(filter.label) + "\n    ")])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "filter-section"
  }, [_c('h4', [_vm._v("Minimum Score")]), _vm._v(" "), _c('el-rate', {
    attrs: {
      "colors": ['#99A9BF', '#F7BA2A', '#FF9900'],
      "texts": ['Poor', 'Fair', 'Average', 'Good', 'Excellent'],
      "show-text": ""
    },
    on: {
      "change": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.minScore),
      callback: function($$v) {
        _vm.$set(_vm.filters, "minScore", $$v)
      },
      expression: "filters.minScore"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-section"
  }, [_c('h4', [_vm._v("Tone / Emotion")]), _vm._v(" "), _c('el-checkbox-group', {
    on: {
      "change": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.selectedTones),
      callback: function($$v) {
        _vm.$set(_vm.filters, "selectedTones", $$v)
      },
      expression: "filters.selectedTones"
    }
  }, _vm._l((_vm.toneOptions), function(tone) {
    return _c('el-checkbox', {
      key: tone.value,
      staticClass: "d-block mb-1",
      attrs: {
        "label": tone.label
      }
    }, [_vm._v("\n        " + _vm._s(_vm.capitalize(tone.label)) + "\n      ")])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-section"
  }, [_c('h4', [_vm._v("Tags")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "multiple": "",
      "placeholder": "Select tags"
    },
    on: {
      "change": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.selectedTags),
      callback: function($$v) {
        _vm.$set(_vm.filters, "selectedTags", $$v)
      },
      expression: "filters.selectedTags"
    }
  }, _vm._l((_vm.tagOptions), function(tag) {
    return _c('el-option', {
      key: tag,
      attrs: {
        "label": tag,
        "value": tag
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "filter-section"
  }, [_c('h4', [_vm._v("Max Length (seconds)")]), _vm._v(" "), _c('el-slider', {
    attrs: {
      "max": 120,
      "step": 5,
      "show-stops": ""
    },
    on: {
      "change": _vm.applyFilters
    },
    model: {
      value: (_vm.filters.maxLength),
      callback: function($$v) {
        _vm.$set(_vm.filters, "maxLength", $$v)
      },
      expression: "filters.maxLength"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center mt-1"
  }, [_vm._v(_vm._s(_vm.filters.maxLength) + "s")])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-4 pt-3 border-top"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-fw fa-star"
  }), _vm._v(" Trending Topics")]), _vm._v(" "), _c('div', {
    staticClass: "cloud-wrapper"
  }, [_c('cloud', {
    attrs: {
      "data": _vm.wordCloudData,
      "fontSizeMapper": _vm.fontSizeMapper,
      "padding": 3,
      "width": "250",
      "height": "150"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f372aca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/analytics/voiceIntelligence/FiltersSidebar.vue
// module id = 3240
// module chunks = 3